class AxSeo extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-ax-seo-toggle]');
    this.content = this.querySelector('[data-ax-seo-content]');
    if (!this.toggle || !this.content) return;
    this.toggle.addEventListener('click', () => this.#toggle());
  }

  #toggle() {
    const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
    this.toggle.setAttribute('aria-expanded', String(!expanded));
    this.content.toggleAttribute('data-expanded', !expanded);
  }
}

customElements.define('ax-seo', AxSeo);
